import { Stepper } from "@mantine/core";
import { BackButton } from "shared/components/global/BackButton";
import { Content } from "shared/components/global/Content";
import { useIpawsAlertFormContext } from "shared/components/ipaws/alert/context";
import { IpawsAlertFormArea } from "shared/components/ipaws/alert/IpawsAlertFormArea";
import { IpawsAlertFormConfiguration } from "shared/components/ipaws/alert/IpawsAlertFormConfiguration";
import { IpawsAlertFormConnectionStatus } from "shared/components/ipaws/alert/IpawsAlertFormConnectionStatus";
import { IpawsAlertFormContent } from "shared/components/ipaws/alert/IpawsAlertFormContent";
import { IpawsAlertFormProfile } from "shared/components/ipaws/alert/IpawsAlertFormProfile";
import { IpawsTemplateFormStepLayout } from "shared/components/ipaws/template/IpawsTemplateFormStepLayout";
import { useFormState } from "shared/hooks/useFormState";
import { useIsMobile } from "shared/hooks/useIsMobile";

export const IpawsTemplateFormLayout = (props: { draftId: string }) => {
    const form = useIpawsAlertFormContext();
    const isMobile = useIsMobile();

    const [step, setStep] = useFormState(form, "meta.step");

    return (
        <Content paper>
            <Content.Heading>
                <BackButton nav={{ to: "/ipaws/templates" }} />
                New IPAWS Alert Template
            </Content.Heading>
            <Content.Action>
                <IpawsAlertFormConnectionStatus />
            </Content.Action>
            <Stepper active={step} onStepClick={setStep} size="xs" radius="sm" styles={{ steps: { display: isMobile ? "none" : "" } }}>
                <Stepper.Step label="Step 1" description="Profile" allowStepSelect={step >= 0}>
                    <IpawsAlertFormProfile />
                </Stepper.Step>
                <Stepper.Step label="Step 2" description="Configuration" allowStepSelect={step >= 1}>
                    <IpawsAlertFormConfiguration />
                </Stepper.Step>
                <Stepper.Step label="Step 3" description="Geographic Area" allowStepSelect={step >= 2}>
                    <IpawsAlertFormArea />
                </Stepper.Step>
                <Stepper.Step label="Step 4" description="Message Content" allowStepSelect={step >= 3}>
                    <IpawsTemplateFormStepLayout draftId={props.draftId}>
                        <IpawsAlertFormContent />
                    </IpawsTemplateFormStepLayout>
                </Stepper.Step>
            </Stepper>
        </Content>
    );
};
